import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CellContext } from "@tanstack/react-table";
import { observer } from "mobx-react";
import {
  useState,
  useEffect,
  useCallback,
  ChangeEventHandler,
  ChangeEvent,
} from "react";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { ColumnType } from "../../constants/enums/grid-column-type-enum";
import userSettingEnum from "../../constants/enums/user-setting-enum";
import { useStore } from "../../contexts/store-provider";
import agreementManagementStore from "../../core/stores/agreement-management-store";
import IPageInfo, { IPageLimitInfo } from "../../models/ICommon";
import { ISorting } from "../../models/ISorting";
import LoaderButton from "../../shared-components/button/loader-button";
import Grid, { getColumns } from "../../shared-components/Grid/Grid";
import DropdownInput from "../../shared-components/input/DropdownInput";
import DeletePopup from "../../shared-components/popup/delete/delete-popup";
import DeletePopupHOC from "../../shared-components/popup/delete/delete-popup-hoc";
import { formatMessage } from "../../translations/format-message";
import { agreementInitialFilterState } from "../../core/initialState/initial-filter-state";
import noMessageIcon from "../../assets/Images/svg/018-empty.svg";
import Pagination from "../../shared-components/Grid/Pagination";
import { useHistory } from "react-router-dom";
import RoutesConstants from "../../constants/routes.constant";
import { IGetAgreement } from "../../models/forms/IAgreement";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import LanguageSlider from "../../shared-components/language-slider/language-slider";
import Label from "../../shared-components/label/label";
import userTypeEnum from "../../constants/enums/user-type-enum";
import {
  getUserTypeFromLocalStorage,
  getBusinessTypeIdFromLocalStorage,
} from "../../helpers/localstorage-helper";
import { ActionType } from "../../constants/enums/action-type-enum";
import { ModuleType } from "../../constants/enums/module-type-enum";
import { isOperationPermittedRoleBase } from "../../helpers/action-permission-helper";
import toast from "react-hot-toast";

const AgreementList = (props: any) => {
  const { preferencesStore, masterManagementStore } = useStore();
  const history = useHistory();
  const { userSetting, setUserSetting } = preferencesStore;
  const {
    agreementList,
    getAllAgreementList,
    resetAgreementFilterDetail,
    setAgreementFilter,
    GetAllAgreementListService,
    getAgreementFilter,
    deleteAgreementService,
    addUpdateAgreementState,
    resetAddAgreement,
    getAllAgreementListState,
    resetDeleteAgreement,
    deleteAgreementState,
  } = agreementManagementStore;
  const { GetAllBusinessTypeListService, getAllBusinessTypes } =
    masterManagementStore;

  const [selectedId, setSelectedId] = useState(-1);
  const [allAgreementList, setAllAgreementList] = useState(getAllAgreementList);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const pageLimitOptions: Array<number> = [10, 50, 100];
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  useEffect(() => {
    GetAllBusinessTypeListService();
  }, [GetAllBusinessTypeListService]);

  useEffect(() => {
    let mappedData = getAllAgreementList.map((agreement: IGetAgreement) => {
      let type = getAllBusinessTypes.find(
        (bt) => Number(bt.id) === Number(agreement.BusinessTypeId)
      );
      return {
        ...agreement,
        BusinessTypeId: type?.value ?? "",
      };
    });
    setAllAgreementList(mappedData);
  }, [setAllAgreementList, getAllAgreementList, getAllBusinessTypes]);

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pageInfo.totalPages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  // useEffect(() => {
  //   setPageInfo({
  //     ...pageInfo,
  //     totalPages: agreementList?.PagingDetails?.TotalPages,
  //     isPagerChange: false,
  //   });
  //   setDisablePagination(false);
  // }, [getAllAgreementList]);
  //
  // useEffect(() => {
  //   if (pageInfo.isPagerChange) {
  //     callGetStaffManagementListService();
  //   }
  // }, [pageInfo.currentPage]);

  const [freeWordName, setFreeWordName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showInvalidAgreements, setShowInvalidAgreements] = useState(
    agreementInitialFilterState.IsInvalid ?? false
  );

  const [businessTypeSearch, setBusinessTypeSearch] = useState(
    agreementInitialFilterState.BusinessTypeId ?? -1
  );
  const [searchText, setSearchText] = useState("");
  const [openPanel, setOpenPanel] = useState(false);
  const [sorting, setSorting] = useState<ISorting>({
    column: "agreementname",
    orderBy: "asc",
  });

  const userType = getUserTypeFromLocalStorage();
  const businessTypeId = getBusinessTypeIdFromLocalStorage();

  const callGetAgreementListService = useCallback(() => {
    const getBusinessTypeId =
      userType === userTypeEnum[userTypeEnum.HeadQuarter]
        ? businessTypeId
        : businessTypeSearch !== -1
        ? businessTypeSearch
        : undefined;
    const filter: {
      businessTypeId?: number;
      showInvalid: boolean;
      freeword?: string;
    } = {
      showInvalid: showInvalidAgreements,
    };
    if (getBusinessTypeId !== undefined) {
      filter.businessTypeId = getBusinessTypeId;
    }
    if (searchQuery) {
      filter.freeword = searchQuery;
    }
    GetAllAgreementListService(
      pageInfo.currentPage,
      pageLimitInfo.pageLimit,
      sorting.orderBy,
      sorting.column,
      filter
    );
  }, [
    GetAllAgreementListService,
    searchQuery,
    pageInfo.currentPage,
    pageLimitInfo.pageLimit,
    sorting.orderBy,
    sorting.column,
    businessTypeSearch,
    userType,
    businessTypeId,
    showInvalidAgreements,
  ]);

  useEffect(() => {
    callGetAgreementListService();
  }, [callGetAgreementListService]);

  useEffect(() => {
    if (addUpdateAgreementState.success) {
      callGetAgreementListService();
      resetAddAgreement();
    }
  }, [
    addUpdateAgreementState.success,
    callGetAgreementListService,
    resetAddAgreement,
  ]);

  const handleSortingChange = (accessor: string) => {
    let sortOrder = sorting.orderBy;
    if (accessor === sorting.column) {
      sortOrder = sorting.orderBy === "asc" ? "desc" : "asc";
    }
    setSorting({ column: accessor, orderBy: sortOrder });
  };

  const handleFreeWordSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFreeWordName(e.target.value);
    },
    []
  );

  const handleSearchClick = useCallback(() => {
    setSearchQuery(freeWordName.trim());
    if (freeWordName.trim().length > 0) {
      setAgreementFilter({
        ...getAgreementFilter,
        AgreementName: freeWordName.trim(),
        IsFilterActive: true,
      });
    }
  }, [freeWordName, getAgreementFilter, setAgreementFilter]);

  useEffect(() => {
    const trimmed = freeWordName.trim();
    if (userTypeEnum[userTypeEnum.SuperAdmin] === userType) {
      if (
        trimmed === "" &&
        !showInvalidAgreements &&
        businessTypeSearch === -1
      ) {
        // Clear filter to load all agreements
        setAgreementFilter({
          AgreementName: "",
          IsFilterActive: false,
          BusinessTypeId: -1,
          IsInvalid: false,
        });
        resetAgreementFilterDetail();
        setFreeWordName("");
        setSearchText("");
        setSearchQuery("");
        setShowInvalidAgreements(false);
        setBusinessTypeSearch(-1);
      }
    } else {
      if (trimmed === "" && !showInvalidAgreements) {
        // Clear filter to load all agreements
        setAgreementFilter({
          AgreementName: "",
          IsFilterActive: false,
          BusinessTypeId: businessTypeId,
          IsInvalid: false,
        });
        setAgreementFilter({
          BusinessTypeId: businessTypeId,
          IsInvalid: false,
          IsFilterActive: false,
          AgreementName: "",
        });
        setFreeWordName("");
        setSearchText("");
        setSearchQuery("");
        setShowInvalidAgreements(false);
        setBusinessTypeSearch(businessTypeId);
      }
    }
  }, [
    businessTypeId,
    businessTypeSearch,
    callGetAgreementListService,
    freeWordName,
    resetAgreementFilterDetail,
    setAgreementFilter,
    showInvalidAgreements,
    userType,
  ]);

  const handleBusinessTypeSearch: ChangeEventHandler<HTMLSelectElement> =
    useCallback((event: ChangeEvent<HTMLSelectElement>) => {
      const selectedBusinessType = Number(event.target.value);
      setBusinessTypeSearch(selectedBusinessType);
      setAgreementFilter({
        IsFilterActive: true,
        AgreementName: freeWordName.trim(),
        BusinessTypeId: selectedBusinessType,
        IsInvalid: showInvalidAgreements,
      });
    }, []);

  const handleInvalidAgreementFilter = useCallback(() => {
    setShowInvalidAgreements((prev: any) => !prev);
    setAgreementFilter({
      ...getAgreementFilter,
      IsFilterActive: true,
    });
  }, [getAgreementFilter, setAgreementFilter]);

  const deleteClickHandler = (Id: any) => {
    setSelectedId(Id);
    props.deletePopupToggleHandler();
  };

  const deleteHandler = () => {
    deleteAgreementService(selectedId);
  };

  useEffect(() => {
    if (deleteAgreementState.success) {
      toast.success(formatMessage("deleted_success"));
    }
  }, [deleteAgreementState.success]);

  useEffect(() => {
    if (deleteAgreementState.success) {
      resetDeleteAgreement();
      props.deletePopupToggleHandler();
      callGetAgreementListService();
    }
  }, [
    deleteAgreementState.success,
    callGetAgreementListService,
    resetDeleteAgreement,
    props,
  ]);

  useEffect(() => {
    if (deleteAgreementState.error) {
      if (deleteAgreementState.error === "HeadQuarterInUse")
        props.deletePopupToggleHandler();
      toast.error(formatMessage("agreement_in_use"));
      resetDeleteAgreement();
    }
  }, [deleteAgreementState.error, resetDeleteAgreement, props]);

  useEffect(() => {
    if (userTypeEnum[userTypeEnum.SuperAdmin] === userType) {
      if (
        Number(businessTypeSearch) === -1 &&
        !showInvalidAgreements &&
        freeWordName === ""
      ) {
        resetAgreementFilterDetail();
      }
    } else {
      if (!showInvalidAgreements && freeWordName === "") {
        setAgreementFilter({
          IsFilterActive: false,
          IsInvalid: false,
          BusinessTypeId: businessTypeSearch,
          AgreementName: "",
        });
      }
    }
  }, [
    freeWordName,
    businessTypeSearch,
    resetAgreementFilterDetail,
    setAgreementFilter,
    showInvalidAgreements,
    userType,
  ]);

  const openAddAgreementHandler = ({ id }: any) => {
    setSelectedId(id);
    if (id > 0) {
      history.push(`${RoutesConstants.AgreementDetails}`, {
        AgreementId: id,
      });
    } else {
      history.push(`${RoutesConstants.AgreementRegistration}`, {
        AgreementId: id,
      });
    }
  };

  const columns = getColumns<any, number>(
    isOperationPermittedRoleBase(
      ModuleType.AgreementManegement,
      ActionType.Delete
    ) && userType === userTypeEnum[userTypeEnum.HeadQuarter]
      ? [
          {
            columnType: ColumnType.Hidden,
            accessorKey: "Id",
          },
          {
            columnType: ColumnType.Sorting,
            accessorKey: "AgreementName",
            displayName: "agreement_name",
            sortingName: "agreementname",
          },
          {
            columnType: ColumnType.Sorting,
            accessorKey: "BusinessTypeId",
            displayName: "business_type",
            sortingName: "businesstype",
          },
          {
            columnType: ColumnType.JsxElement,
            jsxElementFormatter: (info: CellContext<any, any>) => {
              const row = info.row.original;
              return (
                <>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => {
                      openAddAgreementHandler({ id: Number(row.Id) });
                    }}
                  >
                    {isOperationPermittedRoleBase(
                      ModuleType.AgreementManegement,
                      ActionType.Add
                    ) ? (
                      <>
                        <i className="bi bi-pencil"></i>
                      </>
                    ) : (
                      <>
                        <i className="bi bi-eye"></i>
                      </>
                    )}
                  </Button>

                  <Button
                    variant="danger"
                    size="sm"
                    className="ms-2"
                    onClick={() => {
                      deleteClickHandler(row.Id);
                    }}
                  >
                    <>
                      <i className="bi bi-trash"></i>
                    </>
                  </Button>
                </>
              );
            },
            accessorKey: "isEdit",
            displayName: "",
            headerClassName: "last-column",
          },
        ]
      : [
          {
            columnType: ColumnType.Hidden,
            accessorKey: "Id",
          },
          {
            columnType: ColumnType.Sorting,
            accessorKey: "AgreementName",
            displayName: "agreement_name",
            sortingName: "agreementname",
          },
          {
            columnType: ColumnType.Sorting,
            accessorKey: "BusinessTypeId",
            displayName: "business_type",
            sortingName: "businesstype",
          },
          {
            columnType: ColumnType.JsxElement,
            jsxElementFormatter: (info: CellContext<any, any>) => {
              const row = info.row.original;
              return (
                <Button
                  variant="primary"
                  className="ms-2"
                  size="sm"
                  onClick={() => {
                    openAddAgreementHandler({ id: Number(row.Id) });
                  }}
                >
                  {isOperationPermittedRoleBase(
                    ModuleType.AgreementManegement,
                    ActionType.Add
                  ) ? (
                    <>
                      <i className="bi bi-pencil"></i>
                    </>
                  ) : (
                    <>
                      <i className="bi bi-eye"></i>
                    </>
                  )}
                </Button>
              );
            },
            accessorKey: "isEdit",
            displayName: "",
            headerClassName: "last-column",
          },
        ],
    sorting,
    handleSortingChange
  );
  return (
    <>
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_agreement"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_agreement_confirm"
          isLoading={false}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="agreement_list" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="various_settings" />
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <FormattedMessage id="agreement_list" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-6">
            <ul className="add-list">
              <li>
                <LanguageSlider />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container-fluid mt-4 p-0">
        <div className="row align-items-md-center mb-3">
          <div className="col-lg-7 col-sm-8 col-12 search_box">
            <div className="row g-1">
              <div className="col-md-5 col-12">
                <div className="input-group">
                  <div className="input-group-text">
                    <span role="button" onClick={handleSearchClick}>
                      <FontAwesomeIcon icon={faSearch} />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={formatMessage("search_by_free_word")}
                    value={freeWordName}
                    onChange={handleFreeWordSearch}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearchClick();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-md-5 col-12">
                {userType !== userTypeEnum[userTypeEnum.HeadQuarter] && (
                  <div className="input-group">
                    <div className="input-group-text">
                      <span
                        role="button"
                        onClick={() => {
                          setSearchText("");
                          setFreeWordName("");
                        }}
                      >
                        <Label
                          className="label-style"
                          required={false}
                          label="business_type"
                        />
                      </span>
                    </div>
                    <DropdownInput
                      className="form-control"
                      value={businessTypeSearch}
                      onChange={handleBusinessTypeSearch}
                      options={getAllBusinessTypes.map((option: any) => ({
                        label: option.value,
                        value: option.id,
                      }))}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-sm-4 col-12">
            <div className="d-flex justify-content-end align-items-center flex-wrap gap-2">
              <input
                type="checkbox"
                className="form-check-input m-0"
                checked={showInvalidAgreements}
                onChange={() => handleInvalidAgreementFilter()}
              />
              <label className="form-check-label ms-1">
                {formatMessage("show_invalid_agreements")}
              </label>
              {getAgreementFilter.IsFilterActive && (
                <button
                  className={`ms-3 btn ${
                    getAgreementFilter.IsFilterActive
                      ? "btn-primary"
                      : "btn-outline-secondary"
                  }`}
                  onClick={() => {
                    resetAgreementFilterDetail();
                    setFreeWordName("");
                    setSearchText("");
                    setSearchQuery("");
                    setShowInvalidAgreements(false);
                    setBusinessTypeSearch(-1);
                  }}
                  title={formatMessage(
                    getAgreementFilter.IsFilterActive
                      ? "clear_filter"
                      : "apply_filter"
                  )}
                >
                  <svg
                    id="fi_3126668"
                    enableBackground="new 0 0 512 512"
                    height="18"
                    viewBox="0 0 512 512"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#ffffff"
                  >
                    <g>
                      <path d="m215.546 85.327h-162.264c-18.073 0-28.679 20.379-18.31 35.187.133.199-3.448-4.682 130.024 177.006 5.921 8.587 4.149-.599 4.149 190.987 0 19.245 21.993 30.358 37.542 18.791 57.536-43.372 71.516-48.257 71.516-70.955 0-133.909-1.721-130.311 4.149-138.823l27.851-37.923c-70.082-25.496-112.087-99.608-94.657-174.27z"></path>
                      <path d="m281.951 30.166c-75.076 67.31-38.685 187.35 55.962 206.05 75.479 15.948 143.193-43.867 143.193-116.945 0-102.594-122.364-157.159-199.155-89.105zm118.529 106.804c9.515 9.466 2.715 25.676-10.603 25.676-8.014 0-10.022-3.79-28.462-22.158-18.064 17.984-20.27 22.158-28.472 22.158-13.349 0-20.063-16.264-10.603-25.676l17.769-17.699-17.769-17.699c-14.107-14.035 7.142-35.322 21.216-21.297l17.859 17.779 17.849-17.779c14.074-14.025 35.331 7.254 21.216 21.297l-17.769 17.699z"></path>
                    </g>
                  </svg>
                </button>
              )}
              {isOperationPermittedRoleBase(
                ModuleType.AgreementManegement,
                ActionType.Add
              ) && (
                <button
                  className="btn btn-primary ms-3"
                  onClick={() => {
                    openAddAgreementHandler({ id: -1 });
                  }}
                >
                  <i className="bi bi-plus-lg me-1"></i>
                  {formatMessage("add_agreement")}
                </button>
              )}
            </div>
          </div>
        </div>
        {allAgreementList.length > 0 ? (
          <div className={`${openPanel ? "panelOpen" : ""}`}>
            <div>
              <div className="card changingPanel">
                <div className="tableDesign row-eq-height tableDevices">
                  <div className="table-responsive" data-testid="table">
                    {allAgreementList && (
                      <Grid
                        data={allAgreementList}
                        columns={columns}
                        isInProgress={false}
                        hiddenColumns={["Id"]}
                      />
                    )}
                    {getAllAgreementListState.inProgress && (
                      <FormLoader
                        loading={getAllAgreementListState.inProgress}
                      />
                    )}
                  </div>
                </div>
              </div>
              {getAllAgreementList.length > 0 ? (
                <div className="d-flex align-items-center justify-content-center p-2 tableFooter">
                  <Pagination
                    isRefreshPage={pageInfo.isRefreshPage}
                    totalPages={pageInfo.totalPages}
                    pageLimit={pageLimitInfo.pageLimit}
                    onPageChanged={onPageChanged}
                    disablePagination={disablePagination}
                    setIsRefreshPage={setIsRefreshPage}
                  />

                  <select
                    data-testid="pageSelect"
                    className="pageLimit ms-1"
                    onChange={onPageLimitChanged}
                    value={pageLimitInfo.pageLimit}
                  >
                    {pageLimitOptions.map((op) => (
                      <option key={op} value={op}>
                        {op} {formatMessage("rows")}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <div className="message text-center">
            <img src={noMessageIcon} alt="" className="no_message" />
            <p className="noData text-muted text-center h4 mb-0">
              <FormattedMessage id="no_agreement" />
            </p>
            <p className="mb-3">{formatMessage("no_agreement_message")}</p>
            {isOperationPermittedRoleBase(
              ModuleType.AgreementManegement,
              ActionType.Add
            ) && (
              <LoaderButton
                text="add_agreement"
                onClick={() => {
                  openAddAgreementHandler({ id: -1 });
                }}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default DeletePopupHOC(observer(AgreementList));
